@if (showNavigation$ | async) {
  @if (placement$ | async; as placement) {
    <wl-sticky-header
      [language]="language$ | async"
      [isLoggedIn]="isLoggedIn$ | async"
      [isMainNavigationAvailable]="isMainNavigationAvailable$ | async"
      [currentNavItems]="mainNavigationItems$ | async"
      [originalNavItems]="mainNavigationItems$ | async"
      [isTopNavigationAvailable]="isTopNavigationAvailable$ | async"
      [topNavigationItems]="topNavigationItems$ | async"
      [openNavigation]="openNavigation$ | async"
      [isServiceNavigationAvailable]="serviceNavigationActive$ | async"
      [showCategories]="showCategories$ | async"
      [serviceNavigationLink]="serviceNavigationLink$ | async"
      [serviceNavigationTitle]="serviceNavigationTitle$ | async"
      [brandLogoLinkUrl]="brandLogoLinkUrl$ | async"
      [loginUrlLabel]="loginUrlLabel$ | async"
      [loginUrl]="loginUrl"
      [mainNavigationTitle]="mainNavigationTitle$ | async"
    >
    </wl-sticky-header>
  }
}
